
<div>
    <app-bar :title="t('app_structures_title')"></app-bar>

    <v-container fluid class="px-6 pt-6 pb-8">
        <v-alert
            type="info"
            text
            dense
            class="mb-6"
        >{{ t('app_structures_text_intro') }}</v-alert>

        <v-card
            elevation="0"
            rounded="lg"
        >
            <v-card-title class="px-6 pt-5 pb-3">
                <v-switch
                    v-model="unpublished"
                    inset
                    hide-details
                    class="mt-0 pt-0"
                    :label="t('app_structures_label_unpublished_only')"
                    @change="capture"
                ></v-switch>

                <v-spacer></v-spacer>

                <publish-app-structure-modal @success="capture">
                    <template #default="{ on, attrs }">
                        <v-btn
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon left>mdi-upload</v-icon>
                            {{ t('app_structures_action_publish') }}
                        </v-btn>
                    </template>
                </publish-app-structure-modal>
            </v-card-title>

            <v-card-text class="px-6 pb-4">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :loading="busy"
                    item-key="version_hash"
                    :items-per-page="50"
                    :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
                    :no-data-text="t('general_text_no_data')"
                >
                    <template #item.version_hash="{ item }">
                        <code :title="item.version_hash">{{ short(item.version_hash) }}</code>
                        <v-btn
                            icon
                            x-small
                            class="ml-1"
                            :title="t('app_structures_action_copy_hash')"
                            @click="copy(item.version_hash)"
                        >
                            <v-icon x-small>mdi-content-copy</v-icon>
                        </v-btn>
                    </template>

                    <template #item.platform="{ item }">{{ item.platform || '-' }}</template>

                    <template #item.app_version="{ item }">{{ item.app_version || '-' }}</template>

                    <template #item.published="{ item }">
                        <v-chip
                            small
                            dark
                            :color="item.published ? 'success' : 'error'"
                        >{{ item.published ? t('app_structures_text_published') : t('app_structures_text_missing') }}</v-chip>
                    </template>

                    <template #item.published_at="{ item }">{{ date(item.published_at) }}</template>

                    <template #item.first_seen_at="{ item }">
                        {{ item.first_seen_at ? date(item.first_seen_at) : t('app_structures_text_not_seen') }}
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</div>
